import { Dialog, DialogContent } from "@mui/material";
import styles from './index.module.scss';
import { ImagePreviewProps } from "../../../types/imagePreviewInfo";

const ImagePreview: React.FC<ImagePreviewProps> = ({ imageUrl, altText  , setOpen, isOpen}) => {
  
    console.log("ImagePreview component rendered with imageUrl:", imageUrl, " altText:", altText, "isOpen:", isOpen);
    return (
        <div className={styles.imagePreviewContainer}>
            <Dialog
                open={isOpen}
                onClose={() => {
                    setOpen(false);
                }}
                maxWidth="md"
                fullWidth
                sx={{
                    "& .MuiPaper-root": {
                        width: "auto",
                        minWidth: "200px",
                        padding: "20px",
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                    },

                }}
            >
                <DialogContent className={styles.dialogueContainer}>
                    <img
                        src={imageUrl}
                        alt={altText}
                        className={styles.image}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ImagePreview;